import Select from "components/widgets/Select";
import useApp from "hooks/useApp";
import classNames from "utilities/ClassNames";
export default function LargeConfiguration({
  large,
  setLarge,
  handleConfiguration,
  setScreen,
  configError,
}: any) {
  const { isScaled } = useApp();
  return (
    <form className="flex flex-col gap-3 w-11/12 mx-auto">
      {/* K1 */}
      <div className="flex flex-1 gap-3 w-full items-center">
        <div className="w-1/2">
          <input
            placeholder="Name"
            className={classNames(isScaled ? "text-lg h-11" : "", "input")}
            type="text"
            required
            value={large.k1.name}
            onChange={(e: any) =>
              setLarge((prev: any) => ({
                ...prev,
                k1: {
                  ...large.k1,
                  name: e.target.value,
                },
              }))
            }
          />
        </div>
        <div className="w-1/2">
          <Select
            id={large.k1.id}
            selectedValue={large.k1.value}
            type={large.k1.type}
            clear={() =>
              setLarge((prev: any) => ({
                ...prev,
                k1: {
                  id: "",
                  name: "",
                  value: "",
                  type: "",
                },
              }))
            }
            select={({ item, typeSelected }: any) => {
              setLarge((prev: any) => ({
                ...prev,

                k1: {
                  ...large.k1,
                  id: item.id,
                  value: item,
                  type: typeSelected,
                },
              }));
            }}
          />
        </div>
      </div>
      {/* K2 */}
      <div className="flex flex-1 gap-3 w-full items-center">
        <div className="w-1/2">
          <input
            placeholder="Name"
            className={classNames(isScaled ? "text-lg h-11" : "", "input")}
            type="text"
            required
            value={large.k2.name}
            onChange={(e: any) =>
              setLarge((prev: any) => ({
                ...prev,
                k2: {
                  ...large.k2,
                  name: e.target.value,
                },
              }))
            }
          />
        </div>
        <div className="w-1/2">
          <Select
            id={large.k2.id}
            selectedValue={large.k2.value}
            type={large.k2.type}
            clear={() =>
              setLarge((prev: any) => ({
                ...prev,
                k2: {
                  id: "",
                  name: "",
                  value: "",
                  type: "",
                },
              }))
            }
            select={({ item, typeSelected }: any) => {
              setLarge((prev: any) => ({
                ...prev,

                k2: {
                  ...large.k2,
                  id: item.id,
                  value: item,
                  type: typeSelected,
                },
              }));
            }}
          />
        </div>
      </div>
      {/* K3 */}
      <div className="flex flex-1 gap-3 w-full items-center">
        <div className="w-1/2">
          <input
            placeholder="Name"
            className={classNames(isScaled ? "text-lg h-11" : "", "input")}
            type="text"
            required
            value={large.k3.name}
            onChange={(e: any) =>
              setLarge((prev: any) => ({
                ...prev,
                k3: {
                  ...large.k3,
                  name: e.target.value,
                },
              }))
            }
          />
        </div>
        <div className="w-1/2">
          <Select
            id={large.k3.id}
            selectedValue={large.k3.value}
            type={large.k3.type}
            clear={() =>
              setLarge((prev: any) => ({
                ...prev,
                k3: {
                  id: "",
                  name: "",
                  value: "",
                  type: "",
                },
              }))
            }
            select={({ item, typeSelected }: any) => {
              setLarge((prev: any) => ({
                ...prev,

                k3: {
                  ...large.k3,
                  id: item.id,
                  value: item,
                  type: typeSelected,
                },
              }));
            }}
          />
        </div>
      </div>

      <div className="flex gap-1 justify-end mt-3">
        <div className="text-red">{configError}</div>
        <div className="flex items-center gap-3">
          <div
            onClick={() => {
              setScreen("");
            }}
            className="btn-sec"
          >
            Cancel
          </div>
          <div onClick={handleConfiguration} className="btn">
            Commit
          </div>
        </div>
      </div>
    </form>
  );
}
